import React, { type ReactNode } from 'react';
import { di } from 'react-magnetic-di';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Link from '@atlaskit/link';
import { useIntl } from '@atlassian/jira-intl';
import {
	FireOperationalAnalytics,
	fireUIAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import imageUrl from '../../assets/something-wrong.svg';
import { ErrorPage } from '../../common/ui/ErrorPage.tsx';
import messages from './messages.tsx';

export type JSErrorPageProps = {
	error?: Error | null;
	isFullPage?: boolean;
};

const reloadPage = (_: unknown, analyticsEvent: UIAnalyticsEvent) => {
	di(window);
	fireUIAnalytics(analyticsEvent, 'clicked button', 'errorPageReloadPage');
	// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.location.reload(true);
};

const statusPage = 'https://status.atlassian.com/';

export function JSErrorPage(props: JSErrorPageProps) {
	const { formatMessage } = useIntl();

	function getDescription(hasError: boolean): React.ReactNode {
		if (hasError) {
			return formatMessage(messages.descriptionWithError, {
				link: (chunks: ReactNode[]) => (
					<Link
						href="https://support.atlassian.com/contact"
						onClick={(_, analyticsEvent) => {
							fireUIAnalytics(analyticsEvent, 'clicked link', 'errorPageContactSupport');
						}}
					>
						{chunks}
					</Link>
				),
			});
		}

		return formatMessage(messages.description);
	}

	return (
		<>
			<FireOperationalAnalytics action="rendered" actionSubject="errorPage" />
			<ErrorPage
				header={formatMessage(messages.header)}
				description={getDescription(Boolean(props.error))}
				// We don't want to tell the user to visit the status page if there's an error available.
				// This is because we will show the error hash and potentially trace ID.
				// The user can then can share with that support.
				linkMessage={props.error ? undefined : formatMessage(messages.linkText)}
				linkHref={props.error ? undefined : statusPage}
				buttonMessage={formatMessage(messages.reloadPageButton)}
				onButtonClick={reloadPage}
				imageUrl={imageUrl}
				error={props.error}
				isFullPage={props.isFullPage}
			/>
		</>
	);
}

export default JSErrorPage;
